<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0626 19.9377C11.9255 19.9377 11.0001 19.0123 11.0001 17.8751C11.0001 16.738 11.9255 15.8126 13.0626 15.8126C14.1997 15.8126 15.1251 16.738 15.1251 17.8751C15.1251 19.0123 14.1997 19.9377 13.0626 19.9377ZM4.12503 6.87505C5.26216 6.87505 6.18755 7.80043 6.18755 8.93757C6.18755 10.0747 5.26216 11.0001 4.12503 11.0001C2.9879 11.0001 2.06252 10.0747 2.06252 8.93757C2.06252 7.80043 2.9879 6.87505 4.12503 6.87505ZM13.0626 14.4376C11.3294 14.4376 9.90557 15.7321 9.67251 17.4021L4.59734 12.3276C6.26798 12.0939 7.56255 10.6707 7.56255 8.93753C7.56255 7.04207 6.02048 5.5 4.12503 5.5C2.22957 5.5 0.6875 7.04207 0.6875 8.93753C0.6875 9.8801 1.07044 10.7347 1.68644 11.3562C1.68988 11.3596 1.69126 11.3644 1.6947 11.3685L10.6323 20.3061C10.6364 20.3095 10.6412 20.3102 10.6446 20.3144C11.2668 20.9304 12.1207 21.3126 13.0626 21.3126C14.958 21.3126 16.5001 19.7705 16.5001 17.8751C16.5001 15.9796 14.958 14.4376 13.0626 14.4376Z"
      fill="#181433"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0001 0.6875C10.6199 0.6875 10.3126 0.995502 10.3126 1.37501C10.3126 1.75451 10.6199 2.06251 11.0001 2.06251C15.9282 2.06251 19.9377 6.07204 19.9377 11.0001C19.9377 11.3796 20.245 11.6876 20.6252 11.6876C21.0054 11.6876 21.3127 11.3796 21.3127 11.0001C21.3127 5.31372 16.6865 0.6875 11.0001 0.6875Z"
      fill="#181433"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0001 4.125C10.6199 4.125 10.3126 4.433 10.3126 4.81251C10.3126 5.19201 10.6199 5.50001 11.0001 5.50001C14.0327 5.50001 16.5002 7.96747 16.5002 11.0001C16.5002 11.3796 16.8075 11.6876 17.1877 11.6876C17.5679 11.6876 17.8752 11.3796 17.8752 11.0001C17.8752 7.20915 14.791 4.125 11.0001 4.125Z"
      fill="#181433"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0626 11C13.0626 11.3795 13.37 11.6875 13.7501 11.6875C14.1303 11.6875 14.4377 11.3795 14.4377 11C14.4377 9.10457 12.8956 7.5625 11.0001 7.5625C10.6199 7.5625 10.3126 7.8705 10.3126 8.25001C10.3126 8.62951 10.6199 8.93751 11.0001 8.93751C12.1373 8.93751 13.0626 9.86289 13.0626 11Z"
      fill="#181433"
    />
  </svg>
</template>

<script>
export default {
  name: 'CallIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-6 w-6',
    },
  },
}
</script>
